import Image from 'next/image'
import { PartnershipConfig } from '@/features/code/partnership-config'

export function PartnershipLogos({ partnership }: { partnership: PartnershipConfig }) {
    if (!partnership.logo) return null

    return (
        <>
            <div className="flex flex-row items-center gap-[25px] mb-12">
                <Image
                    src={partnership.logo.src}
                    alt={partnership.logo.alt}
                    width={partnership.logo.width}
                    height={partnership.logo.height}
                    className="object-contain"
                />

                <svg
                    className="h-[14.28px] w-[14.28px] shrink-0"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                >
                    <line x1="0" y1="0" x2="24" y2="24" />
                    <line x1="24" y1="0" x2="0" y2="24" />
                </svg>

                <Image
                    src="/_images/navigation/neotaste-logo.svg"
                    alt="NeoTaste Logo"
                    width={60}
                    height={46}
                    className="object-contain"
                    priority
                />
            </div>

            <div className="w-full h-px bg-white/20 mb-12" />
        </>
    )
}
